import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Button, Sheet, Stack, Typography } from '@healthinal/ui';
import { captureException } from '@sentry/react';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import Logo from '../assets/logo.svg?react';
import { ErrorBoundary } from '../components/errors/ErrorBoundary.tsx';
import { ErrorCard } from '../components/errors/ErrorCard.tsx';
import { interpretError } from '../components/errors/errors.tsx';
import { HEADER_HEIGHT_PADDING_PX, MAX_WIDTH_PX } from '../theme.ts';
import { Header } from './components/Header.tsx';

export const Route = createRootRoute({
  component: Root,
  // All errors should be handled by the ErrorBoundary above, unless rendering the root route itself goes wrong.
  // Letting it bubble outside the router is not possible at this time: https://github.com/TanStack/router/issues/1181
  onCatch: (error) => captureException(error),
  errorComponent: ({ error }) => <ErrorCard {...interpretError(error)} />,
});

function Root() {
  const { instance: msalInstance } = useMsal();
  return (
    <ErrorBoundary isRoot>
      <AuthenticatedTemplate>
        <Stack sx={{ mx: 'auto', maxWidth: MAX_WIDTH_PX }}>
          <Header />
          <Stack
            sx={{
              paddingLeft: 3,
              paddingTop: `${HEADER_HEIGHT_PADDING_PX}px`,
              height: '100vh',
            }}>
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </Stack>
        </Stack>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <div
          style={{
            display: 'grid',
            placeItems: 'center',
            minHeight: '100vh',
          }}>
          <Sheet
            sx={{
              my: 5,
              p: 3,
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              borderRadius: 'md',
              boxShadow: 'md',
            }}
            variant="outlined">
            <Stack display={'flex'} alignItems={'center'}>
              <Logo width={70} height={70} />
              <Typography level="h4" component="h1">
                <b>TB-App</b>
              </Typography>
              <Typography level="body-sm">Bitte einloggen, um fortzufahren.</Typography>
            </Stack>
            <Button onClick={() => msalInstance.loginRedirect()}>Login</Button>
          </Sheet>
        </div>
      </UnauthenticatedTemplate>
    </ErrorBoundary>
  );
}
